<template>
  <v-app id="welcome-wrap">
    <div class="help-layout">
      <!-- Header -->
      <header-welcome></header-welcome>

      <div class="help-contents">
        <!-- List -->
        <div class="help-list">
          <v-card tile flat>
            <v-list>
              <v-list-item>
                <v-list-item-title>가이드 2021 (준비 중)</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list-group v-model="open_old_guide">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>옛날 가이드 보기</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item-group v-model="item_key">
                <v-list-item v-for="(item, i) in items" :key="i" :disabled="i==6">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ item.text }}
                      <span class="beta" v-if="i==6">준비중</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-card>
        </div>

        <!-- Contents -->
        <div class="help-item">
          <div v-if="item_key==0">
            <h1>빠른 시작 안내</h1>
            <p>
              요즘 쓰고 있는 논문이나 출판 프로젝트가 있으신가요? <br>
              떠오르셨다면, 비블리오트리즈를 시작할 준비가 되셨네요!
            </p>

            <h2>
              <span class="pms205--text">1단계</span>
              프로젝트 만들기
            </h2>
            <p>
              비블리오트리즈에 가입하시면 '랩' 화면으로 이동합니다. 랩은 당신의 다양한 프로젝트를 모아두는 곳입니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_1_1.png" alt=""/>
            </v-card>
            <p>
              '새 프로젝트 생성'을 클릭해 프로젝트를 생성해봅시다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_1_2.png" alt=""/>
            </v-card>
            <p>
              보기 모드로 프로젝트에 진입 시 먼저 보이는 화면을 설정할 수 있습니다. '트리형' 또는 '노트형'을 선택합니다. <br>
              원하는 제목과 설명을 넣어 '지금 시작하기'를 누르면, 새로 만든 프로젝트가 '진행 중인 프로젝트'로 분류됩니다. <br>
              '나중에 시작하기'를 누르면, '예정된 프로젝트'로 분류됩니다.
            </p>

            <h2>
              <span class="pms205--text">2단계</span>
              도큐먼트 추가하기
            </h2>
            <p>
              새 프로젝트를 생성하면 프로젝트 화면으로 진입합니다. <br>
              프로젝트 화면에서는 도큐먼트(참고문헌)를 관리하고 분석하면서 리뷰와 워킹페이퍼를 작성할 수 있습니다.
            </p>
            <p>
              프로젝트를 생성할 때 설정한 '보기 모드'에 따라 프로젝트 진입 시의 기본 화면이 달라집니다. <br>
              '트리형'으로 설정할 경우 참고문헌 네트워크(트리)가, '노트형'으로 설정할 경우 워킹페이퍼가 먼저 보이게 됩니다.
            </p>
            <p>
              화면 상단에서 모드를 변경할 수 있습니다. <br>
              기본 '보기 모드'는 프로젝트 제목 우측의 화살표를 클릭해 정보를 수정하는 방식으로 변경합니다. <br>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_2_1.png" alt=""/>
            </v-card>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_2_2.png" alt=""/>
            </v-card>
            <p>
              '새 도큐먼트 추가'를 클릭해 논문, 보고서, 컨퍼런스 자료 등 당신의 도큐먼트를 추가할 수 있습니다. <br>
            </p>
            <p>
              도큐먼트는 다음과 같은 방법으로 입력할 수 있습니다. <a @click="item_key=2">링크</a>에서 자세한 방법을 확인하세요.
              <ul>
                <li>'업로드'를 클릭해 EndNote 파일(.enw, .ris)을 업로드하기 (지원되는 형식은 지속적으로 추가될 예정입니다)</li>
                <li>직접 정보 입력하기</li>
                <li>갤러리에서 가져오기</li>
              </ul>
            </p>
            <p>
              다시 랩으로 돌아가기 위해서는 화면 상단의 '랩' 버튼을 눌러주세요.
            </p>

            <h2>
              <span class="pms205--text">3단계</span>
              노트 작성하기
            </h2>
            <p>
              프로젝트와 도큐먼트마다 당신의 노트를 작성할 수 있습니다. <a @click="item_key=3">링크</a>에서 자세한 방법을 확인하세요. <br>
              워킹 페이퍼나 논문, 도큐먼트 리뷰를 작성하고 자동저장 기능으로 안전하게 보관하세요.<br>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_3_1.png" alt=""/>
            </v-card>
            <p>
              웹 기반의 비블리오트리즈는 인터넷이 연결된 어느 장치에서나 쉽게 열어 작업을 시작할 수 있습니다.
            </p>
            <p>
              오늘부터 연구는 비블리오트리즈와 함께 하세요!
            </p>
          </div>

          <div v-if="item_key==1">
            <h1>프로젝트 생성 및 관리</h1>
            
            <h2>랩 화면 소개</h2>
            <p>
              랩은 당신의 프로젝트를 모아두는 '홈'입니다. <br>
              논문, 보고서, 학기말 과제 등 당신이 원하는 프로젝트를 생성하고 관리할 수 있습니다. <br>
              랩 화면은 아래와 같이 구성됩니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_1_1.png" alt=""/>
            </v-card>

            <h2>새 프로젝트 만들기</h2>
            <p>
              오른편 상단의 '새 프로젝트 생성'을 클릭해 프로젝트를 생성할 수 있습니다. <br>
              원하는 제목과 설명을 넣어 저장하면 새 프로젝트가 만들어집니다.
              <span class="ref">※ 단, 동일한 제목의 프로젝트는 생성할 수 없습니다.</span> <br>
              보기 모드를 통해 프로젝트 진입 시 노트와 트리 중 무엇을 먼저 보여줄지 설정할 수 있습니다. <br>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_1_1_2.png" alt=""/>
            </v-card>

            <h2>프로젝트 관리하기</h2>
            <p>
              프로젝트 목록은 카드나 리스트 형태로 볼 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_3_1.png" alt=""/>
            </v-card>

            <p>
              프로젝트에 이미지를 설정하면 카드 뷰에서 이미지가 먼저 보이도록 설정됩니다.
              카드에 커서를 올리면 상세정보를 볼 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_1_1.png" alt=""/>
            </v-card>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_3_2.png" alt=""/>
            </v-card>

            <h2>프로젝트 정보 수정하기</h2>
            <p>
              프로젝트 화면에서 제목 오른편의 화살표를 클릭하세요. <br>
              프로젝트의 제목, 설명, 상태, 보기 모드, 이미지를 설정하거나, 아예 삭제할 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_4_1.png" alt=""/>
            </v-card>
            <v-card max-width="600px">
              <v-img src="/static/guide_2_4_2.png" alt=""/>
            </v-card>
            <p>
              상태 설정에 따라 랩 화면에서 프로젝트를 구분할 수 있습니다.
            </p>
          </div>

          <div v-if="item_key==2">
            <h1>프로젝트에 도큐먼트 추가</h1>

            <h2>프로젝트 화면 소개</h2>
            <p>
              프로젝트 화면은 도큐먼트(연구자료)를 관리하고 분석하면서 당신의 글을 작성하는 곳입니다. <br>
              제목 옆의 화살표를 클릭하면 프로젝트의 정보를 수정할 수 있습니다. <br>
              보기 모드 변경을 통해 프로젝트 진입 시 기본 화면을 트리 또는 노트로 바꿀 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_3_1_1.png" alt=""/>
            </v-card>

            <h2>프로젝트에 도큐먼트 추가하기</h2>
            <p>
              프로젝트에 도큐먼트를 추가하면 레퍼런스 트리가 생성됩니다. 도큐먼트를 다음 세 가지 방법으로 추가할 수 있습니다.
              <ul>
                <li>EndNote 파일(.enw, .ris)을 업로드하기</li>
                <li>직접 정보를 입력하기</li>
                <li>갤러리에서 가져오기</li>
              </ul>
            </p> 
            <h3>
              <span class="pms205--text">방법 1</span>
              EndNote 파일(.enw, .ris)을 업로드하기
            </h3>
            <p>
              <ol>
                <li><a href="https://scholar.google.com" target="_blank">Google Scholar</a>, <a href="https://kiss.kstudy.com" target="_blank">KISS</a> 등 학술정보 사이트에서 개별 도큐먼트 또는 검색 목록의 서지사항을 다양한 포맷으로 다운받을 수 있습니다. 이 중 비블리오트리즈가 지원하는 .ris 혹은 .enw 형식의 서지사항 정보를 다운받으세요.</li>
                <li>비블리오트리즈의 프로젝트 화면으로 돌아와 오른편의 '새 도큐먼트 추가'를 누릅니다.</li>
                <li>상단의 '업로드'를 클릭하고 다운로드한 서지사항 파일을 엽니다. <br>
                  <span class="ref">※ 여러 파일을 동시에 올릴 수 있으나, 한 번에 너무 많은 파일을 열 경우 업로드 시간이 오래 걸릴 수 있습니다.</span>
                </li>
                <v-card max-width="600px">
                  <v-img src="/static/guide_3_2_1.png" alt=""/>
                </v-card>
                <li>입력이 완료되면 업로드한 도큐먼트의 정보가 뜹니다. 원하는 도큐먼트를 선택해 프로젝트에 추가할 수 있습니다. <br>
                  <span class="ref">※ 하늘색 바탕의 느낌표는 이미 프로젝트에 추가된 도큐먼트임을 나타냅니다.</span> <br>
                  <span class="ref">※ 비블리오트리즈에서는 사용자들이 입력한 서지사항이 공유됩니다. 기존에 입력된 서지사항과 자신이 입력한 서지사항의 내용이 다를 경우, 주황색 바탕의 느낌표가 뜹니다.
                    느낌표를 클릭해 기존의 서지사항을 개선할 수 있습니다.</span>
                </li>
                <v-card max-width="600px">
                  <v-img src="/static/guide_3_2_2.png" alt=""/>
                </v-card>
              </ol>
            </p>
            <h3>
              <span class="pms205--text">방법 2</span>
              직접 정보 입력하기
            </h3>
            <p>
              <ol>
                <li>오른편의 '새 도큐먼트 추가'를 누릅니다.</li>
                <li>도큐먼트 유형을 설정한 뒤, 필수 항목을 입력합니다. 
                  <a @click="types_opened_1=!types_opened_1">
                    <span v-if="!types_opened_1">도큐먼트 유형 보기</span>
                    <span v-else>도큐먼트 유형 닫기</span>
                  </a>
                </li>
                <div v-if="types_opened_1">
                  <div v-for="(t, i) in Object.keys(doc_types)" :key="i">
                    <span :style="setColor(t)" class="dot"></span>
                    <span>{{ $t('doc_types.'+doc_types[t].keyname) }}</span>
                  </div>
                </div>
                <v-card max-width="600px">
                  <v-img src="/static/guide_3_2_1.png" alt=""/>
                </v-card>
                <li>제목을 입력하면 in-app 검색을 통해 도큐먼트를 추천합니다. 
                  원하는 도큐먼트가 있을 경우, 해당 타이틀을 클릭하면 해당 정보가 입력됩니다. <br> 
                  <span class="ref">※ 이미 프로젝트에 포함된 도큐먼트일 경우, 하늘색 바탕의 느낌표가 표시됩니다.</span> <br>
                <v-card max-width="600px">
                  <v-img src="/static/guide_3_3_3.png" alt=""/>
                </v-card>
                <li>입력을 완료하고 '추가하기' 버튼을 누르면 프로젝트에 도큐먼트가 추가됩니다.<br>
                  <span class="ref">※ 비블리오트리즈에서는 사용자들이 입력한 서지사항이 공유됩니다. 
                    기존에 입력된 서지사항과 자신이 입력한 서지사항의 내용이 다를 경우, 주황색 바탕의 느낌표가 뜹니다. 
                    느낌표를 클릭해 기존의 서지사항을 개선할 수 있습니다.</span>
                </li>
                <v-card max-width="600px">
                  <v-img src="/static/guide_3_3_4.png" alt=""/>
                </v-card>
              </ol>
            </p>
            <h3>
              <span class="pms205--text">방법 3</span>
              갤러리에서 가져오기
            </h3>
            <p>
              갤러리 기능은 2020년 여름에 공식 오픈할 예정입니다.
            </p>
            <!-- <p>
              <ol>
                <li>랩 화면으로 이동해 왼쪽 상단의 '갤러리'를 누릅니다.</li>
                <li>
                  갤러리는 비블리오트리즈의 사용자 모두가 공유하는 공간으로, 주제, 인물, 저작을 테마로 한 도큐먼트 모음이 전시됩니다.
                  이 도큐먼트 모음을 비블리오트리즈에서는 '마스터피스'라고 부릅니다. <br>
                  관심있는 마스터피스를 선택합니다.
                </li>
                <li>마스터피스 화면에서 마스터피스 전체 혹은 마스터피스가 포함하는 도큐먼트를 내 프로젝트로 가져올 수 있습니다. <br>
                  마스터피스 제목 오른편의 '가져오기' 아이콘을 클릭하면 마스터피스 전체의 도큐먼트가, 도큐먼트 리스트의 개별 도큐먼트 오른편의 '가져오기' 아이콘을 클릭하면 해당 도큐먼트를 가져올 수 있습니다. <br>
                  원하는 '가져오기' 아이콘을 클릭합니다.
                </li>
                <li>가져올 도큐먼트를 넣을 프로젝트를 선택해 확인 버튼을 누릅니다.</li>
                <v-card>gif: 갤러리에서 퍼오는 과정</v-card>
              </ol>
            </p> -->
          </div>

          <div v-if="item_key==3">
            <h1>도큐먼트 관리 및 리뷰 작성</h1>

            <h2>도큐먼트 목록 보기</h2>
            <p>
              프로젝트 화면의 도큐먼트 목록에서는 프로젝트와 연관된 도큐먼트 정보를 볼 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_1_1.png" alt=""/>
            </v-card>
            <p>
              도큐먼트 목록 상단의 '프로젝트 도큐먼트' 탭에서는 프로젝트에 포함된 도큐먼트를, <br>
              '트리 도큐먼트' 탭에서는 레퍼런스 트리에 속한 모든 도큐먼트의 정보를 볼 수 있습니다. <br>
              프로젝트에 따라 '제안' 탭이 생성됩니다.
              '제안' 탭에서는 비블리오트리즈에서 중요하다고 판단되는 도큐먼트를 강조해 보여줍니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_1_2.png" alt=""/>
            </v-card>
            <p>
              목록은 카드나 리스트 형태로 볼 수 있으며, 정렬과 검색 기능을 통해 원하는 도큐먼트를 빠르게 추출할 수 있습니다. <br>
              중요한 도큐먼트에 별 표기를 남겨보세요.
            </p>
            <p>
              도큐먼트에 남긴 리뷰를 모두 펼치거나, 도큐먼트 여러 개를 선택해 프로젝트에서 제외할 수 있습니다. <br>
              프로젝트에서 도큐먼트가 제외되더라도, 랩의 '리뷰' 페이지에서 당신이 남긴 모든 리뷰를 확인할 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_1_3.png" alt=""/>
            </v-card>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_1_4.png" alt=""/>
            </v-card>
            
            <h2>도큐먼트 상세 정보 확인하기</h2>
            <p>
              도큐먼트의 제목을 클릭하면 도큐먼트 상세 정보를 볼 수 있습니다. 도큐먼트 상세 화면은 아래와 같습니다.
            </p>
            <p>
              도큐먼트 상세 정보 최상단의 툴바에서는 도큐먼트 리스트로 돌아가거나, 프로젝트에서 추가 또는 제거할 수 있습니다. <br>
              '이전', '다음' 버튼을 통해 목록 내 다른 도큐먼트로 더욱 편하게 이동하세요.<br>
              도큐먼트가 잘못 입력되어 있을 경우 '신고' 아이콘을 눌러 무엇이 잘못되었는지 알려주세요.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_2_1.png" alt=""/>
            </v-card>
            <p>
              도큐먼트의 상세 정보에는 참고문헌, 번역본, 개정본, 상세 목차 등이 포함됩니다.
              이러한 문서 간의 관계는 레퍼런스 트리에서도 확인할 수 있습니다.
            </p>
            <p>
              모든 도큐먼트는 유형을 가집니다. 
              <a @click="types_opened_2=!types_opened_2">
                <span v-if="!types_opened_2">도큐먼트 유형 보기</span>
                <span v-else>도큐먼트 유형 닫기</span>
              </a>
              <div v-if="types_opened_2">
                <div v-for="(t, i) in Object.keys(doc_types)" :key="i">
                  <span :style="setColor(t)" class="dot"></span>
                  <span>{{ $t('doc_types.'+doc_types[t].keyname) }}</span>
                </div>
              </div>
            </p>

            <h2>도큐먼트 리뷰 남기기</h2>
            <p>
              모든 도큐먼트에는 당신만의 리뷰를 남길 수 있습니다. <br>
              리뷰는 도큐먼트의 인용문이나 요약본일 수도 있고, 비평일 수도 있습니다. <br>
              원하는 목적에 맞게 리뷰를 남겨보세요. <br>
              '내 리뷰' 오른편의 '편집' 아이콘을 눌러 글을 작성하세요. <br>
              <span class="ref">※ 비블리오트리즈에서는 사용자들이 입력한 서지정보가 공유되지만, 리뷰는 개인적인 정보로 공유되지 않습니다.</span> <br>
              <span class="ref">※ 도큐먼트 리뷰의 최대 용량은 2.0MB 입니다.</span> <br>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_3_1.png" alt=""/>
            </v-card>
            <p>
              리뷰를 편집하는 동안 원고의 드래프트가 자동으로 저장됩니다. <br>
              드래프트의 저장 여부는 에디터의 상단에서 확인할 수 있습니다. <br>
              글을 완전히 저장하려면 하단의 '저장' 버튼을 눌러주세요. <br>
              '취소' 버튼을 누르면 알림 후 글이 최종 저장 시점으로 변환됩니다. <br>
              <span class="ref">※ '저장' 또는 '취소'를 실행할 경우 이전 상태로 복원할 수 없습니다.</span>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_3_2.png" alt=""/>
            </v-card>
            <p>
              도큐먼트 리뷰 상단의 '더보기' 아이콘을 눌러 리뷰를 워드로 추출하거나 삭제할 수 있습니다. <br>
              <span class="ref">※ '삭제'를 실행할 경우 이전 상태로 복원할 수 없습니다.</span>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_4_3_3.png" alt=""/>
            </v-card>

            <h2>도큐먼트에 참고문헌 추가하기</h2>
            <p>
              도큐먼트에 참고문헌을 추가해 레퍼런스 트리를 확장할 수 있습니다. <br>
              레퍼런스 오른편의 '더하기' 아이콘을 눌러 도큐먼트 추가와 동일한 방식으로 참고문헌을 추가하세요. (<a @click="item_key=2" href="#">도큐먼트 추가 방법 보기</a>)
            </p>

            <v-card max-width="600px">
              <v-img src="/static/guide_4_4_1.png" alt=""/>
            </v-card>

            <h2>도큐먼트 신고하기</h2>
            <p>
              도큐먼트 정보가 잘못 입력되어 있나요? 
              도큐먼트 상세 정보나 관계 정보가 잘못 입력되어 있는 경우, 도큐먼트 상세 정보 상단의 신고 버튼을 눌러 무엇이 잘못되었는지 알려주세요.
              운영자가 확인 후 정보를 바르게 수정해드립니다.
            </p>
          </div>

          <div v-if="item_key==4">
            <h1>트리 활용 방법</h1>
            <p>
              프로젝트 화면의 '트리' 모드에서는, 당신이 추가한 도큐먼트를 기반으로 레퍼런스 트리가 그려집니다. <br>
              트리를 통해 관심 있는 주제의 중요한 도큐먼트와 연구의 흐름을 한눈에 파악해보세요.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_5_1_1.png" alt=""/>
            </v-card>

            <h2>트리의 구성 확인하기</h2>
            <p>
              트리의 시작은 당신의 프로젝트입니다. <br>
              프로젝트는 화면의 맨 아래에 사각형으로 표시되며, 이 프로젝트와 연결된 노드는 당신이 프로젝트에 포함시킨 도큐먼트를 나타냅니다. <br>
              이들 노드에는 외곽선이 있습니다.
            </p>
            <p>
              노드 위에 쓰여진 번호는 오른편 도큐먼트 목록에 쓰인 번호와 동기화됩니다. <br>
              노드의 색상은 도큐먼트 유형에 따라 다르며, 링크는 도큐먼트 간의 관계를 보여줍니다. <br>
              도큐먼트 간의 관계는 '참고', '번역', '개정', '부분'으로 구성됩니다. 자세한 사항은 트리 왼편의 범례를 참고하세요.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_5_1_2.png" alt=""/>
            </v-card>
            <p>
              노드에 마우스를 올리면 간략한 정보를 확인할 수 있으며, 노드를 클릭하면 오른편에 상세 정보가 나타납니다. <br>
              마우스 휠로 트리를 확대/축소하고, 원상복구를 원할 시에는 '새로고침' 버튼을 클릭하면 됩니다.
            </p>
            <p>
              도큐먼트 목록 위에 마우스를 올리면 트리에서 노드의 위치를 파악할 수 있습니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_5_1_3.png" alt=""/>
            </v-card>

            <h2>트리 해석하기</h2>
            <p>
              레퍼런스 트리는 방향성 있는 비순환 그래프(Directed Acyclic Graph, DAG)입니다. <br>
              아래에 위치한 도큐먼트는 위에 있는 도큐먼트를 참고합니다. <br>
              도큐먼트 A가 도큐먼트 B의 참고문헌일 경우, 도큐먼트 A는 도큐먼트 B보다 무조건 상단에 배치됩니다. <br>
              따라서 트리 상단에 위치한 도큐먼트일수록 오래된 도큐먼트일 가능성이 높습니다.
            </p>
            <p>
              레퍼런스 분석을 돕는 트리의 종류는 꾸준히 업데이트될 예정입니다.
            </p>

            <h2>트리의 도큐먼트를 프로젝트에 추가하기</h2>
            <p>
              도큐먼트가 프로젝트에 포함되어 있지 않을 경우 이를 프로젝트에 포함시킬 수 있습니다. <br>
              원하는 도큐먼트를 클릭해 도큐먼트 상세 정보 화면의 최상단에서 '추가' 버튼을 눌러주세요.
              이미 추가된 도큐먼트일 경우 해당 버튼은 비활성화 상태입니다.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_5_2_1.png" alt=""/>
            </v-card>
            <p>
              새로운 도큐먼트가 추가되면 레퍼런스 트리의 형태가 변형됩니다.
              도큐먼트를 프로젝트에 추가/제외하면서 중요한 도큐먼트를 탐색해보세요!
            </p>
          </div>

          <div v-if="item_key==5">
            <h1>프로젝트 노트 작성</h1>

            <h2>노트 편집하기</h2>
            <p>
              프로젝트마다 당신만의 노트를 작성할 수 있습니다. <br>
              프로젝트 화면의 노트 모드에서 워킹 페이퍼나 논문을 작성하고 자동저장 기능으로 안전하게 보관하세요. <br>
              프로젝트의 보기 모드를 노트로 설정하시면 노트 작성을 중심으로 프로젝트를 운영할 수 있습니다. <br>
              <span class="ref">※ 프로젝트 노트의 최대 용량은 2.5MB 입니다.</span> <br>
            </p>
            <p>
              글을 편집하는 동안 원고의 드래프트가 자동으로 저장됩니다. 
              드래프트의 저장 여부는 에디터의 상단에서 확인할 수 있습니다.
              글을 완전히 저장하려면 상단의 '저장' 버튼을 눌러주세요.
              '취소' 버튼을 누르면 글이 최종 저장 시점으로 변환됩니다. <br>
              <span class="ref">※ '저장' 또는 '취소'를 실행할 경우 이전 상태로 복원할 수 없습니다.</span>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_6_1_1.png" alt=""/>
            </v-card>

            <h2>도큐먼트 리뷰를 참고하면서 노트 편집하기</h2>
            <p>
              노트를 작성하면서 도큐먼트의 리뷰를 참고할 수 있습니다. 
              오른편 사이드바의 도큐먼트 리스트에서 리뷰를 펼치거나, 특정 도큐먼트를 선택해 리뷰를 확인하세요.
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_6_1_2.png" alt=""/>
            </v-card>

            <h2>노트 추출하기</h2>
            <p>
              노트 상단의 '추출' 버튼을 눌러 프로젝트 노트를 워드로 추출할 수 있습니다.
              <span class="ref">※ 수식과 이미지는 워드 파일의 스타일에 따라 변형될 수 있습니다.</span>
            </p>
            <v-card max-width="600px">
              <v-img src="/static/guide_6_1_3.png" alt=""/>
            </v-card>
            <p>
              향후 도큐먼트 목록을 함께 추출하는 기능이 추가될 예정입니다.
            </p>
          </div>

          <div v-if="item_key==6">
            <h1>갤러리 탐색</h1>

            <h2>갤러리 소개</h2>
            <p>
              갤러리는 비블리오트리즈의 사용자 모두가 공유하는 공간으로, 주제, 인물, 저작을 테마로 한 도큐먼트 모음이 전시됩니다.
              이 도큐먼트 모음을 비블리오트리즈에서는 '마스터피스'라고 부릅니다.
            </p>
            <p>
              마스터피스 목록은 카드나 리스트 형태로 볼 수 있습니다.
              태그 검색을 통해 원하는 주제의 마스터피스를 찾아보세요.
            </p>
            <v-card>png: 갤러리 화면</v-card>

            <h2>마스터피스 테마 소개</h2>

            <h3>마스터피스: 인물</h3>
            <p>
              인물 테마의 마스터피스에는 특정 인물의 저작들이 포함됩니다.
              마스터피스 트리를 통해 해당 인물의 지적 배경을 탐색해보세요.
              <strong>Bruno Latour의 마스터피스</strong>
            </p>

            <h3>마스터피스: 저작</h3>
            <p>
              저작 테마의 마스터피스는 한 저작(책 또는 논문)의 학문적 배경을 살펴봅니다.
              당신의 관심 분야에서 중요한 저작의 지적 흐름을 확인해보세요.
              <strong>몇 개라도 미리 만드는 것이 낫지 않을지?</strong>
            </p>

            <h3>마스터피스: 주제</h3>
            <p>
              주제 테마의 마스터피스는 특정 저널에서 특정 주제를 다룬 글들이 포함됩니다.
              마스터피스 트리는 시기별로 학문적 토대 및 주요 개념의 변화 - 학문사 또는 개념사 - 를 보여줄 것입니다.
              <strong>몇 개라도 미리 만드는 것이 낫지 않을지?</strong>
            </p>

            <h2>프로젝트로 마스터피스를 가져오기</h2>
            <p>
              관심있는 마스터피스를 선택하면 프로젝트 화면과 유사한 마스터피스 화면이 등장합니다.
            </p>
            <v-card>png: 마스터피스 화면</v-card>
            <p>
              마스터피스 화면에서 마스터피스 전체 혹은 마스터피스가 포함하는 도큐먼트에 '좋아요'를 누르거나, 내 프로젝트로 가져올 수 있습니다. <br>
              마스터피스 제목 오른편의 '가져오기' 아이콘을 클릭하면 마스터피스 전체의 도큐먼트가, 도큐먼트 리스트의 개별 도큐먼트 오른편의 '가져오기' 아이콘을 클릭하면 해당 도큐먼트를 가져올 수 있습니다. <br>
              '좋아요' 방식은 '가져오기' 방식과 유사하게 하트 아이콘을 클릭하시면 됩니다.
              좋아한 마스터피스나 도큐먼트는 <strong>어디에서 확인할 수 있습니다.</strong>
            </p>
          </div>

          <div class="next">
            <div v-if="item_key<items.length-1">
              <v-btn small text color="pms205" @click="item_key+=1"
                v-if="item_key<5">
                다음: {{ items[item_key+1].text }}
              </v-btn>
            </div>
            <div>
              <span>아직 필요한 내용을 찾지 못하셨나요?</span>
              <v-btn small text color="pms205"
                :href="'mailto:services@bibliotrees.net'">
                문의하기
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <footer-welcome></footer-welcome>
    </div>
  </v-app>

</template>

<script>
import { doc_types } from '../../../custom/model'

export default {
  metaInfo() {
    return {
      title: "Guide"
    }
  },

  data() {
    return {
      item_key: 0,
      items: [
        { text: '빠른 시작 안내' },
        { text: '프로젝트 생성 및 관리' },
        { text: '프로젝트에 도큐먼트 추가' },
        { text: '도큐먼트 관리 및 리뷰 작성' },
        { text: '트리 활용 방법' },
        { text: '프로젝트 노트 작성' },
        { text: '갤러리 탐색' },
      ],
      doc_types: doc_types,
      types_opened_1: false,
      types_opened_2: false,
      open_old_guide: true,
    }
  },

  watch: {
    item_key: {
      handler(val) {
        if (val===undefined) {
          this.item_key=0
        }
      },
    },
  },

  methods: {
    setColor(doc_type) {
      let color = this.doc_types[doc_type].color
      return 'background-color:'+ color
    },
  },
}
</script>

<style scoped>
  p {
      margin: 0 0 1.7rem !important;
      line-height: 1.7 !important;
  }

  .dot {
    transform: translateY(1px);
  }

  .help-contents {
    max-width: 1280px;
    margin: auto;
    display: grid;
    grid-template-columns: 250px auto;
    padding: 20px;
    font-size: 14px;
    line-height: 24px;
    color: #676168;
  }

  .help-list, .help-item {
    padding-top: 36px;
  }

  .help-item {
    padding-left: 36px;
    margin: 20px;
  }

  h1 {
    font-size: 36px;
    line-height: 48px;
  }

  h2 {
    font-size: 22px;
    line-height: 30px;
    margin-top: 45px;
  }

  h3 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 12px;
  }

  p {
    margin-block-end: 1em;
  }

  .v-card {
    margin: 20px;
  }

  .ref {
    color:#FF770D;;
  }

  .next {
    padding-top: 30px;
    text-align: right;
  }

  /* .next > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  } */

  @media (max-width: 1000px) {
    .help-contents {
      display: flex;
      flex-direction: column;
    }
    .help-item {
      padding-left: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/spa/welcome/Guide.vue